import { API, graphqlOperation } from 'aws-amplify';
import _ from 'lodash';
import { upsertACTag } from '../graphql/mutations';

export const addACTag = async ({ user, tags }: { user: any; tags: string }) => {
  try {
    const req = await API.graphql(graphqlOperation(upsertACTag, { user, tags }));
    return _.get(req, ['data', 'upsertACTag']);
  } catch (err) {
    console.log(err);
    return err;
  }
};
